import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Section } from "../Styled";


export const KontaktFormSection = styled(Section)`
display: flex;
margin: 100px auto;
align-items: flex-start;
justify-content: space-between;
column-gap: 25px;
@media screen and (max-width: 768px) {
    flex-direction: column;
    row-gap: 50px;
    align-items: center;
}
`

export const FormKort = styled.form`
display: flex;
flex-direction: column;
row-gap: 25px;
padding: 25px;
width: 320px;
justify-content: center;
align-items: center;
background-color: #fefefe;
border-radius: 10px;
box-shadow: 0px 4px 30px 0px rgb(0 0 0 / 25%);
& legend {
    font-size: 1.5rem;
}
`

export const FormTitle = styled.legend`
width: 100%;
flex-shrink: 0;
flex-grow: 0;
font-size: 2rem;
font-weight: 700;
text-align: center;
`

export const InputTxtCon = styled.div`
display: flex;
flex-direction: column;
row-gap: 25px;
justify-content: space-evenly;
width: 90%;
`

export const InputTxt = styled.input`
display: flex;
width: 100%;
flex-shrink: 0;
flex-grow: 0;
align-items: center;
height: 50px;
border-radius: 5px;
text-indent: 10px;
font-size: 1.25rem;
font-weight: bold;
border: 2px solid rgb(0 0 29 / 20%);
border-image-slice: 1;
border-image-source: rgb(0 0 29 / 20%);
transition: all 300ms ease-out;
&::-webkit-outer-spin-button,::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
&::placeholder {
    font-size: 1.25rem;
    font-weight: bold;
    color: #aaa;
    transition: all 300ms ease-out;
}
&:focus-visible {
    outline: none;
    border-image-source: linear-gradient(to right,
        #25aae1,
        #4481eb,
        #3f86ed);
    box-shadow: 0px 4px 8px 0px rgb(82 113 255 / 25%);
    outline-offset: 0px;
    &::placeholder {
        color: rgb(17 105 170 / 75%);
    }
}
`

export const AreaInput = styled.textarea`
display: flex;
width: 100%;
flex-shrink: 0;
flex-grow: 0;
align-items: center;
height: 50px;
border-radius: 5px;
text-indent: 10px;
font-size: 1.25rem;
    font-weight: bold;
    border: 2px solid rgb(0 0 29 / 20%);
    border-image-slice: 1;
    border-image-source: rgb(0 0 29 / 20%);
transition: all 300ms ease-out;
&::placeholder {
    font-size: 1.25rem;
    font-weight: bold;
    color: #aaa;
    transition: all 300ms ease-out;
}
&:focus-visible {
    outline: none;
    border-image-source: linear-gradient(to right,
        #25aae1,
        #4481eb,
        #3f86ed);
    box-shadow: 0px 4px 8px 0px rgb(82 113 255 / 25%);
    outline-offset: 0px;
    &::placeholder {
        color: rgb(17 105 170 / 75%);
    }
}
`

export const SubmitBtn = styled.button`
box-sizing: border-box;
  text-align: center;
  width: 200px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  margin: 20px 0;
  height: 55px;
  text-align: center;
  border: none;
  background-size: 300% 100%;

  border-radius: 5px;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.3s ease-out;

  background-image: linear-gradient(
    to right,
    #25aae1,
    #4481eb,
    #04befe,
    #3f86ed
  );
  box-shadow: 0 15px 30px 0 rgba(65, 132, 234, 0.25);

  &:hover {
    background-position: 100% 0;

    transform: translate3d(0, 3px, 0) scale3d(0.95, 0.95, 1);

    box-shadow: 0 5px 10px 0 rgba(65, 132, 234, 0.75);
  }
  &:focus {
    outline: none;
  }
  &:active {
    transform: translate3d(0, 3px, 0) scale3d(0.9, 0.9, 1);
    box-shadow: 0 2px 5px 0 rgba(65, 132, 234, 0.5);
  }
  
`

export const KontRightCon = styled.div`
max-width: 100%;
`

export const KontInfoCon = styled.div`
display: flex;
justify-content: flex-start;
align-items: flex-start;
margin-top: 50px;
column-gap: 50px;
@media screen and (max-width: 550px) {
    flex-direction: column;
}

`

export const KontInfo = styled.a`
text-decoration: none;
color: black;
display: flex;
align-items: center;
margin: 10px 0;
`

export const KontIcon = styled(FontAwesomeIcon)`
background-color: ${({ theme }) => theme.mainColors.lightblu};
height: 15px;
width: 15px;
padding: 10px;
color: ${({ theme }) => theme.mainColors.hvid};
border-radius: 50pc;
margin-right: 10px;
`